import React, { useState } from "react";
import UserSettingsModalTable from "./UserSettingsModalTable";
import AddOrEditReportUsers from "./AddOrEditReportUsers";
import CustomDrawer from "../CustomDrawer";
interface IAddUserSettings {
    addUsersDisplay: boolean;
    setAddUsersDisplay: React.Dispatch<React.SetStateAction<boolean>>;
}

const UserSettingsModal: React.FC<IAddUserSettings> = ({
    addUsersDisplay,
    setAddUsersDisplay,
}) => {

    const closeUserSettingsModal = () => {
        setAddUsersDisplay((prev) => !prev);
    };
    const [updateRecords, setUpdateRecords] = useState(false)

    return (
        <>
            <CustomDrawer
                title="User Settings"
                width={650}
                onClose={closeUserSettingsModal}
                open={addUsersDisplay}
                footer={false}
            >
                <AddOrEditReportUsers addUsersDisplay={addUsersDisplay} setUpdateRecords={setUpdateRecords} isEdit={false} />
                <UserSettingsModalTable {...{ updateRecords, setUpdateRecords }} />
            </CustomDrawer>
        </>
    );
};

export default UserSettingsModal;
